import React from 'react';
import { MapPin } from 'lucide-react';

/*
 * 마무리 상담 블록 — 메인 맨 아래와 '가치' 페이지(/about)가 같이 쓴다.
 * 어느 페이지에서 읽었든 끝에서 할 일은 같다: 찾아가는 상담을 청하는 것.
 */
const ClosingCta = ({ onRequest }) => (
    <section className="px-6 pt-16">
        <div className="max-w-5xl mx-auto rounded-3xl bg-primary-50 border border-primary-100 px-6 py-16 md:py-20 text-center">
            <h2 className="text-3xl/normal md:text-4xl/normal font-extrabold text-gray-900 tracking-tight break-keep">
                몇 개든, 어디든.<br />
                먼저 찾아가겠습니다.
            </h2>
            <button
                type="button"
                onClick={onRequest}
                className="mt-10 inline-flex items-center gap-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-white text-xl font-extrabold px-8 py-4 shadow-soft transition-transform hover:-translate-y-1"
            >
                <MapPin className="w-5 h-5" strokeWidth={2.25} aria-hidden="true" />
                무료 방문 컨설팅 신청
            </button>
        </div>
    </section>
);

export default ClosingCta;
